import { Document, Packer, Paragraph, Table, TableCell, TableRow, TextRun, WidthType, BorderStyle } from 'docx';

export interface WordExportOptions {
  filename: string;
  title: string;
  data: any[][];
}

export const exportToWord = async ({ filename, title, data }: WordExportOptions) => {
  if (data.length === 0) return;

  const headers = data[0];
  const rows = data.slice(1);

  // Create table rows
  const tableRows = [
    // Header row
    new TableRow({
      children: headers.map((header: string) =>
        new TableCell({
          children: [new Paragraph({
            children: [new TextRun({ text: String(header), bold: true })]
          })],
          width: { size: 100 / headers.length, type: WidthType.PERCENTAGE }
        })
      )
    }),
    // Data rows
    ...rows.map((row: any[]) =>
      new TableRow({
        children: row.map((cell: any) =>
          new TableCell({
            children: [new Paragraph({ text: String(cell || '') })],
            width: { size: 100 / headers.length, type: WidthType.PERCENTAGE }
          })
        )
      })
    )
  ];

  // Create table with borders
  const table = new Table({
    rows: tableRows,
    width: { size: 100, type: WidthType.PERCENTAGE },
    borders: {
      top: { style: BorderStyle.SINGLE, size: 1 },
      bottom: { style: BorderStyle.SINGLE, size: 1 },
      left: { style: BorderStyle.SINGLE, size: 1 },
      right: { style: BorderStyle.SINGLE, size: 1 },
      insideHorizontal: { style: BorderStyle.SINGLE, size: 1 },
      insideVertical: { style: BorderStyle.SINGLE, size: 1 }
    }
  });

  // Create document
  const doc = new Document({
    sections: [{
      children: [
        new Paragraph({
          children: [new TextRun({ text: title, bold: true, size: 32 })],
          spacing: { after: 400 }
        }),
        table
      ]
    }]
  });

  // Generate and download
  const blob = await Packer.toBlob(doc);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
